module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate23.4c7df01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate23.png
// module id = 759
// module chunks = 0